module.exports = "/_next/static/images/cdaf2d8186b35fb0ac925b8d9a1f28c5-man-looking-up-smiling-xs@3x.jpg";